import { ChangeDetectorRef, Component, OnInit, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { ValidateRegistrationKeys } from "./regKey.validator";
import { ModalService } from "../../services/modal.service";
import { KeyGenerationModalComponent } from "../modals/key-generation-modal/key-generation-modal.component";
import { ActivationService } from "../../services/activation.service";
import { SnackBarService } from "../../services/snackbar.service";
import { EMPTY } from "rxjs";
import { TranslocoModule, TranslocoService } from "@jsverse/transloco";
import { NgIf } from "@angular/common";


@Component({
    selector: 'dl-liat-activation-form',
    templateUrl: './liat-activation-form.component.html',
    styleUrls: ['./liat-activation-form.component.scss'],
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [ReactiveFormsModule,NgIf,TranslocoModule]
})
export class LiatActivationFormComponent implements OnInit {

  liatActivationForm: FormGroup;
  emailPlaceHolder: string;
  registrationKeyPlaceholder: string;
  public readonly rows = 5;
  public cols = window.innerWidth / 12;
  public isLoading = false;

  constructor(private fb: FormBuilder,
    private modalService: ModalService,
    private snackBarService: SnackBarService,
    private activationService: ActivationService,
    public translocoService: TranslocoService,
    private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.emailPlaceHolder = `Enter Email Address`;
    this.registrationKeyPlaceholder = `Enter Registration Key(s)`;
    this.liatActivationForm = this.fb.group({
      activationType: [null, Validators.required],
      registrationKeys: ['', [Validators.required, ValidateRegistrationKeys()]],
      email: ['', [Validators.email]],
      termsAndConditions: [false, Validators.requiredTrue]
    });    
  }

  onInputChange(event: CustomEvent): void {
    const inputValue = event.detail;
    const control = this.liatActivationForm.get('registrationKeys');
    
    if (control) {
      control.setValue(inputValue, { emitEvent: true });
      control.markAsDirty();
      control.markAsTouched();
      control.updateValueAndValidity();
    }
  }

  onRadioChange(event: CustomEvent): void {
    const selectedValue = event.detail;
    this.liatActivationForm.get('activationType')?.setValue(selectedValue, { emitEvent: false });
    this.liatActivationForm.get('activationType')?.markAsTouched();
    this.liatActivationForm.updateValueAndValidity();
    this.cdr.detectChanges();
  }
  
  onEmailChange(event: CustomEvent): void {
    this.liatActivationForm.get('email')?.setValue(event.detail);
  }
  
  onTermsChange(event: CustomEvent): void {
    this.liatActivationForm.get('termsAndConditions')?.setValue(event.detail, { emitEvent: false });
    this.liatActivationForm.updateValueAndValidity();
    this.cdr.detectChanges();
  }
  

  resetLiatActivationForm() {
    this.liatActivationForm.reset();
  }
  
  formatRegistrationKeys() {
    const registrationKeyValue = this.liatActivationForm.controls['registrationKeys'].value;
    if (registrationKeyValue && registrationKeyValue != '') {
      const formattedRegKeys = registrationKeyValue.replace(/[^a-zA-Z0-9\n]/g, ',');
      this.liatActivationForm.patchValue({
        registrationKeys: formattedRegKeys
      });
    }
  }

  submitLiatActivationForm() {
    this.isLoading = true;
    if (this.liatActivationForm.valid) {
      let registrationKeyValues = this.liatActivationForm.value.registrationKeys;
      let emailId = this.liatActivationForm.value.email;
      let regKeys = this.getRegistrationKeys(registrationKeyValues, emailId);

      if (this.liatActivationForm.value.activationType === 'Software Activation') {
        this.activationService.liatSoftwareActivation(regKeys).subscribe(data => {
          this.isLoading = false;
          this.openKeyGenerationStatusPreviewModal(data);
        }, error => {
          this.isLoading = false;
          this.openErrorSnackBar();
          return EMPTY;
        });
      } else {
        this.activationService.liatAssayActivation(regKeys).subscribe(data => {
          this.isLoading = false;
          this.openKeyGenerationStatusPreviewModal(data);
        }, error => {
          this.isLoading = false;
          this.openErrorSnackBar();
          return EMPTY;
        });
      }
    } else {
      const errorMessage = `Invalid details`;
      this.snackBarService.showError(errorMessage);
    }
  }

  openKeyGenerationStatusPreviewModal(regKeys) {
    this.modalService.showModal<any, any, any>(KeyGenerationModalComponent, regKeys);
  }

  getRegistrationKeys(registrationKeyValue, emailId) {
    const formattedRegKeyList = registrationKeyValue.split(/\,|\n/).filter((data) => data != '');
    const keyList = [];
    formattedRegKeyList.map((data) => {
      if (data && data != "") {
        keyList.push(data);
      }
    });

    let regKeyObj = {
      registrationKey: keyList,
      recipients: emailId
    };
    return regKeyObj;
  }

  private openErrorSnackBar() {
    const errorMessage = `Something went wrong. Please wait a few minutes before you try again.`;
    this.snackBarService.showError(errorMessage);
  }
}
